import { lazyComponent } from "common/lazy-loading";

// TODO We need to find a proper way of fixing this circular dependency
export const LazyRecordFilterContent = lazyComponent(() =>
  // eslint-disable-next-line import/no-cycle
  import("./filters").then((m) => ({ default: m.RecordFilters })),
);
